"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
const colors_1 = require("./colors");
exports.shadows = {
    size: {
        xs: {
            shadowColor: colors_1.colors.shadow.default,
            shadowOffset: {
                width: 0,
                height: 2,
            },
            shadowOpacity: 1,
            shadowRadius: 4,
        },
        sm: {
            shadowColor: colors_1.colors.shadow.default,
            shadowOffset: {
                width: 0,
                height: 2,
            },
            shadowOpacity: 1,
            shadowRadius: 8,
        },
        md: {
            shadowColor: colors_1.colors.shadow.default,
            shadowOffset: {
                width: 0,
                height: 2,
            },
            shadowOpacity: 1,
            shadowRadius: 16,
        },
        lg: {
            shadowColor: colors_1.colors.shadow.default,
            shadowOffset: {
                width: 0,
                height: 2,
            },
            shadowOpacity: 1,
            shadowRadius: 40,
        },
    },
};
//# sourceMappingURL=shadows.js.map